/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetHooksSummaryPayload,
  GetHooksSummaryPayload$Outbound,
  GetHooksSummaryPayload$outboundSchema,
} from "../components/gethookssummarypayload.js";

export type GetHooksSummarySecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetHooksSummarySecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetHooksSummarySecurity = {
  option1?: GetHooksSummarySecurityOption1 | undefined;
  option2?: GetHooksSummarySecurityOption2 | undefined;
};

export type GetHooksSummaryRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getHooksSummaryPayload: GetHooksSummaryPayload;
};

/** @internal */
export type GetHooksSummarySecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetHooksSummarySecurityOption1$outboundSchema: z.ZodMiniType<
  GetHooksSummarySecurityOption1$Outbound,
  GetHooksSummarySecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getHooksSummarySecurityOption1ToJSON(
  getHooksSummarySecurityOption1: GetHooksSummarySecurityOption1,
): string {
  return JSON.stringify(
    GetHooksSummarySecurityOption1$outboundSchema.parse(
      getHooksSummarySecurityOption1,
    ),
  );
}

/** @internal */
export type GetHooksSummarySecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetHooksSummarySecurityOption2$outboundSchema: z.ZodMiniType<
  GetHooksSummarySecurityOption2$Outbound,
  GetHooksSummarySecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getHooksSummarySecurityOption2ToJSON(
  getHooksSummarySecurityOption2: GetHooksSummarySecurityOption2,
): string {
  return JSON.stringify(
    GetHooksSummarySecurityOption2$outboundSchema.parse(
      getHooksSummarySecurityOption2,
    ),
  );
}

/** @internal */
export type GetHooksSummarySecurity$Outbound = {
  Option1?: GetHooksSummarySecurityOption1$Outbound | undefined;
  Option2?: GetHooksSummarySecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetHooksSummarySecurity$outboundSchema: z.ZodMiniType<
  GetHooksSummarySecurity$Outbound,
  GetHooksSummarySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetHooksSummarySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetHooksSummarySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getHooksSummarySecurityToJSON(
  getHooksSummarySecurity: GetHooksSummarySecurity,
): string {
  return JSON.stringify(
    GetHooksSummarySecurity$outboundSchema.parse(getHooksSummarySecurity),
  );
}

/** @internal */
export type GetHooksSummaryRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetHooksSummaryPayload: GetHooksSummaryPayload$Outbound;
};

/** @internal */
export const GetHooksSummaryRequest$outboundSchema: z.ZodMiniType<
  GetHooksSummaryRequest$Outbound,
  GetHooksSummaryRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getHooksSummaryPayload: GetHooksSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getHooksSummaryPayload: "GetHooksSummaryPayload",
    });
  }),
);

export function getHooksSummaryRequestToJSON(
  getHooksSummaryRequest: GetHooksSummaryRequest,
): string {
  return JSON.stringify(
    GetHooksSummaryRequest$outboundSchema.parse(getHooksSummaryRequest),
  );
}
